'use strict';

module.exports = function GoldFileInitialiser({config, pageState, goldFileApi, s3FileModel, collaborationModel, resourceManager, navigatorShim, goldFileChangesModel}, optional) {
	if (!config || !pageState || !goldFileApi || !s3FileModel || !collaborationModel || !resourceManager || !navigatorShim) {
		throw 'invalid-args';
	}
	const obj = this,
		thumbnailBuilder = optional?.thumbnailBuilder;
	obj.initFile = (sendEvent) => {
		if (!sendEvent) {
			return Promise.reject('invalid-args');
		}
		let pathInfo;
		if (pageState.isInitialising) {
			return Promise.resolve();
		}
		if (pageState.isInitialised) {
			sendEvent('reauthenticated');
			return Promise.resolve();
		}
		pageState.isInitialising = true;
		sendEvent('fileLoading');
		return goldFileApi.loadFile(config, pageState, s3FileModel, collaborationModel, resourceManager, navigatorShim, goldFileChangesModel)
		.then((result) => {
			pathInfo = result;
			if (pathInfo.free) {
				sendEvent('freeFileLoaded');
			} else {
				sendEvent('goldFileLoaded');
			}
			sendEvent('fileLoaded', pathInfo.fileId, pageState.getPageTitle());
			sendEvent('fileInfo', pathInfo);
			sendEvent('ready');
		})
		.then(() => {
			if (!pathInfo || !pathInfo.fileId || !pathInfo.gold || pageState.hasThumbnail() || !thumbnailBuilder) {
				return;
			}
			return thumbnailBuilder.build()
			.catch((reason) => {
				sendEvent('thumbnail-creation-failed', reason);
				return false;
			});
		})
		.then((thumbnailUrl) => {
			if (!thumbnailUrl) {
				return;
			}
			return s3FileModel.uploadAsset(pathInfo.fileId, thumbnailUrl, {isThumbnail: true});
		})
		.catch((reason) => {
			if (reason === 'network-error') {
				reason = 'error-' + reason;
			}
			sendEvent('error', reason);
		})
		.then(() => pageState.isInitialising = false)
		.then(() => {
			if (goldFileChangesModel.isTrashed()) {
				sendEvent('trashed');
			}
			return true;
		});
	};
};
